// extracted by mini-css-extract-plugin
export default {"toggleContainer":"ToggleSidenav_toggleContainer__-k5KQ","toggleButton":"ToggleSidenav_toggleButton__wQyMU"};